<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-img src="@/assets/logo.png" class="mx-5 mt-7 mb-4" />
      <v-list dense>
        <template v-for="item in items">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>

          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            :key="item.text"
            :to="item.to"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </template>
      </v-list>
      <v-col cols="12" class="body-2 pt-10">
        <!-- <v-img src="@/assets/logo.png" class="mx-3 my-7" /> -->
        <v-card flat class="grey--text mx-2 mb-3">Ph: 07 5596 6588</v-card>
        <v-card flat class="grey--text mx-2">
          Email: <a href="mailto:info@t2services.com.au">info@t2services.com.au</a>
        </v-card>
        <v-card flat class="grey--text mx-2 mb-3">
          Website:
          <a href="https://www.t2services.com.au/" target="_blank">www.t2services.com.au</a>
        </v-card>
        <v-card flat class="grey--text mx-2 mb-3">
          Unit 5, 91-93 Spencer Road<br />
          Nerang QLD 4211<br />
        </v-card>
        <v-card flat class="grey--text mx-2 mb-3">
          PO Box 2614<br />
          Nerang QLD 4211
        </v-card>
        <v-card flat class="grey--text mx-2">ABN: 88 132 990 437</v-card>
      </v-col>

      <template v-slot:append>
        <div class="mx-1 px-5 py-4">
          <a
            href="https://www.swede.com.au/"
            target="_blank"
            style="text-decoration: none;"
            class="grey--text">
            <small>Built by Swede</small>
          </a>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="green"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
        v-if="$store.state.details"
      >
        <span class="hidden-sm-and-down">{{ $store.state.details.title }}</span>
      </v-toolbar-title>

      <!-- <v-spacer />
      <v-img src="@/assets/logo.png" contain height="40" /> -->

      <v-spacer />

      {{ user.username }}
      <v-btn v-on:click="signOut" title="Sign out" icon>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

export default {
  props: {
    source: String,
  },
  data: () => ({
    user: {},
    dialog: false,
    drawer: null,
    items: [
      {
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
        to: '/',
      },
      {
        icon: 'mdi-playlist-edit',
        text: 'Jobs',
        to: '/jobs',
      },
      {
        icon: 'mdi-account-hard-hat',
        text: 'New Job',
        to: '/new-job',
      },
      {
        icon: 'mdi-contacts',
        text: 'My Details',
        to: '/my-details',
      },
    ],
  }),
  methods: {
    signOut() {
      this.$Amplify.Auth.signOut()
        .then(() => AmplifyEventBus.$emit('authState', 'signedOut'))
        .catch((e) => console.error(e));
    },
  },
  async mounted() {
    this.user = await Auth.currentAuthenticatedUser();
  },
};
</script>

<style>
.signout {
  margin-bottom: -20px;
  margin-top: -5px;
}
</style>
